/* eslint-disable indent */
import { Grid, makeStyles, Tab, Tabs } from '@material-ui/core';
import Loading from 'components/Loading';
import Permission from 'components/ValidPermission';
import i18n from 'i18n';
import { EnvironmentFields } from 'modules/environments/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import {
  CompanyData,
  RolesEnum,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import {
  inAdminView,
  inOperatorView,
  inSuperAdminView,
  isClientOperator,
} from 'utils/role';
import EnvironmentsTemplate from '../Templates/Environments';
import styles from './styles';
import LogsEnvironments from '../LogsEnvironments';
import AuditEnvironments from '../AuditEnvironments';

const useStyles = makeStyles(styles);

interface Props {
  companySelected: CompanyData | null;
  environmentSelected: EnvironmentFields | null;
  permissions?: PermissionsData;
  role?: RolesEnum;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.tabPanelContent}
      hidden={value !== index}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const HistoryEnvironment = ({
  companySelected,
  environmentSelected,
  permissions,
  role,
}: Props) => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <EnvironmentsTemplate
      currentPage="history"
      titlePage={environmentSelected?.name}
      breadcrumbs={[
        {
          name: i18n.t('ENVIRONMENTS_KEY'),
          link: '/environments',
        },
        {
          name: i18n.t('HISTORY_SOP_KEY'),
        },
      ]}
      titleContent={i18n.t('HISTORY_SOP_KEY')}
      subtitleContent={`${environmentSelected?.name ||
        i18n.t('LOADING_KEY')} ${i18n.t('HISTORY_SOP_KEY')}`}
    >
      <Grid container className={classes.rootTabs}>
        <Tabs
          value={currentTab}
          onChange={(e, newValue) => setCurrentTab(newValue)}
          className={clsx({
            [classes.tabsGreen]: inAdminView(role, companySelected),
            [classes.tabsGray]: inSuperAdminView(role, companySelected),
            [classes.tabsBlue]: inOperatorView(role, companySelected),
            [classes.tabsYellow]: companySelected,
          })}
        >
          {!isClientOperator(role) && (
            <Tab
              id="btn-logs"
              label={i18n.t('LOGS_KEY')}
              className={clsx({
                [classes.tabGray]: inSuperAdminView(role, companySelected),
                [classes.tabYellow]: companySelected,
              })}
            />
          )}
          {role === RolesEnum.superAdmin &&
            permissions?.list_all_operators_audit_logs && (
              <Tab
                id="btn-audit"
                label={i18n.t('LOGS_PAGE.LIST_LOGS_KEY')}
                className={clsx({
                  [classes.tabGray]: inSuperAdminView(role, companySelected),
                  [classes.tabYellow]: companySelected,
                })}
              />
            )}
        </Tabs>
      </Grid>

      {environmentSelected ? (
        <Grid container>
          {!isClientOperator(role) && (
            <TabPanel value={currentTab} index={0}>
              <LogsEnvironments />
            </TabPanel>
          )}

          <Permission value="list_all_operators_audit_logs">
            <TabPanel
              value={currentTab}
              index={!isClientOperator(role) ? 1 : 0}
            >
              <AuditEnvironments />
            </TabPanel>
          </Permission>
        </Grid>
      ) : (
        <Loading />
      )}
    </EnvironmentsTemplate>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  environmentSelected,
  permissions: data?.permissions,
  role: data?.role,
});

export default connect(mapStateToProps, {})(HistoryEnvironment);
